import MemberArticlePanel from "./MemberArticlePanel";

/** The Edit — the member's Editorial Feature. Reads/writes the exact article Master Build creates.
 * Cover Star actions moved to the prominent bar at the top of the Members Studio. */

const CATEGORIES = [
  "Innovation", "Success", "Money", "Culture", "Trends",
  "Lifestyle", "Style", "Coaching and Mentoring", "Business", "International",
];

export default function EditSection({ member, article, onArticleChange }) {
  return (
    <MemberArticlePanel
      member={member} article={article} onArticleChange={onArticleChange}
      kind="edit" sectionId="section-edit" tid="edit"
      heading="The Edit" note="their Editorial Feature"
      categories={CATEGORIES}
      publicNote="Publish Now sends this article live to /the-edit under its category."
    />
  );
}
